import { useState } from "react";
import bench from "../../assets/bench.png"
import keymetrix from "../../assets/keymetrix.png"

export function rendernetraaLHConcepts() {
  return <NetraaLHConceptsComponent />;
}

function NetraaLHConceptsComponent() {
  const [zoomImage, setZoomImage] = useState(null);

  return (
  <div className=" text-slate-900 dark:text-slate-100 transition-colors duration-300">

      {/* Main content */}
      <main className="py-10">
        <div className="mx-auto">
          {/* Breadcrumb */}
          <div className="flex flex-wrap items-center gap-2 mb-6 text-sm">
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Netraa LH</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Product Capabilities</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <span className="text-primary font-medium">Global Industry Benchmarking</span>
            </div>

          {/* Header */}
          <div className="mb-12 border-b border-border-light dark:border-border-dark pb-8">
            <h1 className="text-5xl lg:text-5xl font-extrabold mb-6 
               leading-[1.15] pb-1
               bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
                Global Industry Benchmarking
              </h1>
            <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-300">
              The Global Industry Rating feature allows you to benchmark your application’s performance against industry standards and peer competitors.
            </p>
          </div>

          {/* Sections */}
          <section className="mb-16 scroll-mt-24" id="introduction">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Benchmarking Selection</h2>
            </div>
            <div className="prose prose-slate dark:prose-invert max-w-none mb-8">
              <p className="text-slate-600 dark:text-slate-300 mb-4">
                To initiate a benchmark analysis, you must define the scope of your comparison. Select the target <strong>Application</strong> from your managed portfolio and then specify the <strong>Domain/Industry Category</strong> (e.g., Banking, Retail, E-commerce, Insurance) to ensure relevant peer grouping.
              </p>
            </div>

      <img
        src={bench}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(bench)}
      />

          </section>

          <section className="mb-16 scroll-mt-24" id="key-metrics">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Key Metrics Analysis</h2>
            </div>

            <p className="text-slate-600 dark:text-slate-300 mb-6">
              The benchmarking report breaks down performance into critical areas, providing deep insights into where you stand in the market ecosystem.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 border border-border-light dark:border-border-dark">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-primary/10 rounded-lg text-primary">
                    <span className="material-symbols-outlined">pie_chart</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white">Availability &amp; Response Time</h3>
                </div>
                <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                  Visualized through interactive pie charts and trend lines, this metric highlights your uptime percentage and server response latency relative to the industry median.
                </p>
              </div>

              <div className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 border border-border-light dark:border-border-dark">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-primary/10 rounded-lg text-primary">
                    <span className="material-symbols-outlined">military_tech</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white">Ranking Position</h3>
                </div>
                <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                  Your application is classified into tiers based on performance: <span className="font-bold text-green-500">Leading</span>, <span className="font-bold text-yellow-500">Average</span>, or <span className="font-bold text-red-500">Lagging</span>. This clear ranking helps prioritize infrastructure investments.
                </p>
              </div>
            </div>
 
      <img
        src={keymetrix}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(keymetrix)}
      />

          </section>

          <section className="mb-16 scroll-mt-24" id="strategic-benefits">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Strategic Benefits</h2>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="p-6 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center hover:border-primary/50 transition-colors">
                <span className="material-symbols-outlined text-3xl text-primary mb-3">dataset</span>
                <span className="text-xs font-bold uppercase tracking-wide text-slate-900 dark:text-white">Real Industry Data</span>
                <span className="text-[10px] text-slate-500 mt-2 leading-tight">Validated peer metrics</span>
              </div>
              <div className="p-6 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center hover:border-primary/50 transition-colors">
                <span className="material-symbols-outlined text-3xl text-primary mb-3">visibility</span>
                <span className="text-xs font-bold uppercase tracking-wide text-slate-900 dark:text-white">Visual Insights</span>
                <span className="text-[10px] text-slate-500 mt-2 leading-tight">Clear graphical data</span>
              </div>
              <div className="p-6 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center hover:border-primary/50 transition-colors">
                <span className="material-symbols-outlined text-3xl text-primary mb-3">psychology</span>
                <span className="text-xs font-bold uppercase tracking-wide text-slate-900 dark:text-white">Management Awareness</span>
                <span className="text-[10px] text-slate-500 mt-2 leading-tight">Executive-level reporting</span>
              </div>
              <div className="p-6 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center hover:border-primary/50 transition-colors">
                <span className="material-symbols-outlined text-3xl text-primary mb-3">route</span>
                <span className="text-xs font-bold uppercase tracking-wide text-slate-900 dark:text-white">Improvement Roadmap</span>
                <span className="text-[10px] text-slate-500 mt-2 leading-tight">Targeted optimization</span>
              </div>
            </div>
          </section>
          {zoomImage && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomImage(null)}
  >
    <img
      src={zoomImage}
      alt="Zoomed Preview"
      className="max-w-[90vw] max-h-[90vh] rounded-xl shadow-2xl object-contain"
    />
  </div>
)}
        </div>
      </main>
    </div>
);
}